import React from "react";
import { Row, Col } from "react-bootstrap";
import { useFormContext } from "react-hook-form";

import { HookFormRadioButton } from "components";
import { ShippingMethodTypes } from "types";

type ShippingMethodProps = {
	sectionName?: string;
	isLoading?: boolean;
};

const ShippingMethod = ({
	sectionName = "shipping",
	isLoading = false,
}: ShippingMethodProps) => {
	const { register } = useFormContext();
	return (
		<>
			<p>Shipping Method</p>
			<Row className="form-group">
				<Col md={2}>
					<HookFormRadioButton
						id={`${sectionName}.shippingMethodNone`}
						name={`${sectionName}.shippingMethod`}
						register={register}
						value={ShippingMethodTypes.none.value?.toString()}
						label={ShippingMethodTypes.none.displayName}
						blurLoading={isLoading}
					/>
				</Col>
				<Col md={2}>
					<HookFormRadioButton
						id={`${sectionName}.shippingMethodGround`}
						name={`${sectionName}.shippingMethod`}
						register={register}
						value={ShippingMethodTypes.ground.value?.toString()}
						label={ShippingMethodTypes.ground.displayName}
						blurLoading={isLoading}
					/>
				</Col>
				<Col md={2}>
					<HookFormRadioButton
						id={`${sectionName}.shippingMethodTwoDay`}
						name={`${sectionName}.shippingMethod`}
						register={register}
						value={ShippingMethodTypes.two_day.value?.toString()}
						label={ShippingMethodTypes.two_day.displayName}
						blurLoading={isLoading}
					/>
				</Col>
				<Col md={2}>
					<HookFormRadioButton
						id={`${sectionName}.shippingMethodOvernight`}
						name={`${sectionName}.shippingMethod`}
						register={register}
						value={ShippingMethodTypes.overnight.value?.toString()}
						label={ShippingMethodTypes.overnight.displayName}
						blurLoading={isLoading}
					/>
				</Col>
				<Col md={2}>
					<HookFormRadioButton
						id={`${sectionName}.shippingMethodPriority`}
						name={`${sectionName}.shippingMethod`}
						register={register}
						value={ShippingMethodTypes.priority.value?.toString()}
						label={ShippingMethodTypes.priority.displayName}
						blurLoading={isLoading}
					/>
				</Col>
			</Row>
		</>
	);
};

export default ShippingMethod;
